import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Upload, CheckCircle, AlertCircle, Download, XCircle, ChevronDown, ChevronUp } from "lucide-react";

/* ── Mapa CCPET → Nombre (Anexo 1A Ministerio Hacienda) ── */
const CCPET_NOMBRES = {
  '1': 'Ingresos',
  '1.1': 'Ingresos Corrientes',
  '1.1.01': 'Ingresos tributarios',
  '1.1.01.01': 'Impuestos directos',
  '1.1.01.01.014': 'Sobretasa ambiental',
  '1.1.01.01.014.01': 'Sobretasa ambiental - Urbano',
  '1.1.01.01.014.02': 'Sobretasa ambiental -  Rural',
  '1.1.01.01.100': 'Impuesto sobre vehículos automotores',
  '1.1.01.01.101': 'Impuesto a ganadores de sorteos ordinarios y extraordinarios',
  '1.1.01.01.200': 'Impuesto Predial Unificado',
  '1.1.01.01.200.01': 'Impuesto Predial Unificado - Urbano',
  '1.1.01.01.200.02': 'Impuesto Predial Unificado - Rural',
  '1.1.01.01.201': 'Sobretasa Ambiental Áreas Metropolitanas',
  '1.1.01.01.202': 'Sobretasa especial para el distrito de Cartagena',
  '1.1.01.01.203': 'Sobretasa por el alumbrado público',
  '1.1.01.02': 'Impuestos indirectos',
  '1.1.01.02.005': 'Impuesto a la explotación de oro, plata y platino',
  '1.1.01.02.100': 'Impuesto de Registro',
  '1.1.01.02.100.01': 'Impuesto de Registro - Cámaras de Comercio',
  '1.1.01.02.100.02': 'Impuesto de Registro - Oficinas de Instrumentos Públicos',
  '1.1.01.02.101': 'Impuesto de loterías foráneas',
  '1.1.01.02.102': 'Impuesto al degüello de ganado mayor',
  '1.1.01.02.103': 'IVA sobre licores, vinos, aperitivos y similares (régimen anterior)',
  '1.1.01.02.104': 'Impuesto al consumo de licores, vinos, aperitivos y similares',
  '1.1.01.02.104.01': 'Impuesto al consumo de licores',
  '1.1.01.02.104.01.01': 'Impuesto al consumo de licores - Componente Específico',
  '1.1.01.02.104.01.01.01': 'Impuesto al consumo de licores - Componente Específico de Producción Nacional',
  '1.1.01.02.104.01.01.02': 'Impuesto al consumo de licores - Componente Específico de Producción Extranjera',
  '1.1.01.02.104.01.02': 'Impuesto al consumo de licores - Componente Ad Valorem',
  '1.1.01.02.104.01.02.01': 'Impuesto al consumo de licores - Componente Ad Valorem de Producción Nacional',
  '1.1.01.02.104.01.02.02': 'Impuesto al consumo de licores - Componente Ad Valorem de Producción Extranjera',
  '1.1.01.02.104.02': 'Impuesto al consumo de vinos, aperitivos y similares',
  '1.1.01.02.104.02.01': 'Impuesto al consumo de vinos, aperitivos y similares - Componente Específico',
  '1.1.01.02.104.02.01.01': 'Impuesto al consumo de vinos, aperitivos y similares - Componente Específico de Producción Nacional',
  '1.1.01.02.104.02.01.02': 'Impuesto al consumo de vinos, aperitivos y similares - Componente Específico de Producción Extranjera',
  '1.1.01.02.104.02.02': 'Impuesto al consumo de vinos, aperitivos y similares - Componente Ad Valorem',
  '1.1.01.02.104.02.02.01': 'Impuesto al consumo de vinos, aperitivos y similares - Componente Ad Valorem de Producción Nacional',
  '1.1.01.02.104.02.02.02': 'Impuesto al consumo de vinos, aperitivos y similares - Componente Ad Valorem de Producción Extranjera',
  '1.1.01.02.105': 'Impuesto al consumo de cervezas, sifones, refajos y mezclas',
  '1.1.01.02.105.01': 'Impuesto al consumo de cervezas, sifones, refajos y mezclas - Nacionales',
  '1.1.01.02.105.02': 'Impuesto al consumo de cervezas, sifones, refajos y mezclas - Extranjeras',
  '1.1.01.02.106': 'Impuesto al consumo de cigarrillos y tabaco',
  '1.1.01.02.106.01': 'Componente específico del impuesto al consumo de cigarrillos y tabaco',
  '1.1.01.02.106.01.01': 'Componente específico del impuesto al consumo de cigarrillos y tabaco - Nacionales',
  '1.1.01.02.106.01.02': 'Componente específico del impuesto al consumo de cigarrillos y tabaco - Extranjeros',
  '1.1.01.02.106.02': 'Componente ad valorem del impuesto al consumo de cigarrillos y tabaco elaborado',
  '1.1.01.02.106.02.01': 'Componente ad valorem del impuesto al consumo de cigarrillos y tabaco elaborado - Nacionales',
  '1.1.01.02.106.02.02': 'Componente ad valorem del impuesto al consumo de cigarrillos y tabaco elaborado - Extranjeros',
  '1.1.01.02.107': 'Impuesto único al consumo a favor del departamento Archipiélago de San Andrés, Providencia y Santa Catalina',
  '1.1.01.02.108': 'Sobretasa fondo departamental de bomberos',
  '1.1.01.02.109': 'Sobretasa a la gasolina',
  '1.1.01.02.200': 'Impuesto de industria y comercio',
  '1.1.01.02.200.01': 'Impuesto de industria y comercio - sobre actividades comerciales',
  '1.1.01.02.200.02': 'Impuesto de industria y comercio - sobre actividades industriales',
  '1.1.01.02.200.03': 'Impuesto de industria y comercio - sobre actividades de servicios',
  '1.1.01.02.201': 'Impuesto complementario de avisos y tableros',
  '1.1.01.02.202': 'Impuesto a la publicidad exterior visual',
  '1.1.01.02.203': 'Impuesto de circulación y tránsito sobre vehículos de servicio público',
  '1.1.01.02.204': 'Impuesto de delineación',
  '1.1.01.02.205': 'Impuesto de espectáculos públicos nacional con destino al deporte',
  '1.1.01.02.206': 'Impuesto a las ventas por el sistema de clubes',
  '1.1.01.02.207': 'Impuesto de casinos',
  '1.1.01.02.208': 'Impuesto sobre apuestas mutuas',
  '1.1.01.02.209': 'Impuesto al degüello de ganado menor',
  '1.1.01.02.210': 'Impuesto sobre teléfonos',
  '1.1.01.02.211': 'Impuesto de alumbrado público',
  '1.1.01.02.212': 'Sobretasa bomberil',
  '1.1.01.02.213': 'Sobretasa fondo de Seguridad',
  '1.1.01.02.214': 'Impuesto de transporte por oleoductos y gasoductos',
  '1.1.01.02.215': 'Impuesto unificado de fondo de pobres, azar y espectáculos públicos',
  '1.1.01.02.216': 'Impuesto de espectáculos públicos municipal',
  '1.1.01.02.217': 'Sobretasa de solidaridad servicios públicos acueducto, aseo y alcantarillado',
  '1.1.01.02.217.01': 'Sobretasa de solidaridad de servicios públicos - acueducto',
  '1.1.01.02.217.02': 'Sobretasa de solidaridad de servicios públicos - aseo',
  '1.1.01.02.217.03': 'Sobretasa de solidaridad de servicios públicos - alcantarillado',
  '1.1.01.02.218': 'Tasa prodeporte y recreación',
  '1.1.01.02.300': 'Estampillas',
  '1.1.01.02.300.01': 'Estampilla para el bienestar del adulto mayor',
  '1.1.01.02.300.02': 'Estampilla pro desarrollo departamental',
  '1.1.01.02.300.03': 'Estampilla pro desarrollo fronterizo',
  '1.1.01.02.300.04': 'Estampilla fondo departamental de bomberos',
  '1.1.01.02.300.05': 'Estampilla pro electrificación rural',
  '1.1.01.02.300.06': 'Estampilla pro desarrollo de la Universidad de la Amazonia',
  '1.1.01.02.300.07': 'Estampilla la Universidad de Antioquia',
  '1.1.01.02.300.08': 'Estampilla pro ciudadela universitaria del Atlántico',
  '1.1.01.02.300.09': 'Estampilla Universidad de Caldas y Universidad Nacional sede Manizales',
  '1.1.01.02.300.10': 'Estampilla Universidad de Cartagena',
  '1.1.01.02.300.11': 'Estampilla pro creación de la Seccional Universidad de Cartagena en El Carmen de Bolívar',
  '1.1.01.02.300.12': 'Estampilla Universidad del Cauca',
  '1.1.01.02.300.13': 'Estampilla pro Universidad Popular del Cesar',
  '1.1.01.02.300.14': 'Estampilla pro Universidad Tecnológica del Chocó',
  '1.1.01.02.300.15': 'Estampilla pro desarrollo de la Universidad de Córdoba',
  '1.1.01.02.300.16': 'Estampilla pro desarrollo Universidad de Cundinamarca',
  '1.1.01.02.300.17': 'Estampilla pro Universidad de la Guajira',
  '1.1.01.02.300.18': 'Estampilla Universidad de los Llanos',
  '1.1.01.02.300.19': 'Estampilla refundación Universidad del Magdalena',
  '1.1.01.02.300.20': 'Estampilla pro desarrollo de la Universidad de Nariño',
  '1.1.01.02.300.21': 'Estampilla pro desarrollo de la Universidad Pública del Norte de Santander',
  '1.1.01.02.300.22': 'Estampilla pro Universidad del Pacífico',
  '1.1.01.02.300.23': 'Estampilla pro desarrollo del Instituto Técnico del Putumayo',
  '1.1.01.02.300.24': 'Estampilla pro Universidad del Quindío',
  '1.1.01.02.300.25': 'Estampilla pro Universidad Industrial de Santander',
  '1.1.01.02.300.26': 'Estampilla de la Universidad de Sucre',
  '1.1.01.02.300.27': 'Estampilla pro desarrollo de la Universidad Surcolombiana del Huila',
  '1.1.01.02.300.28': 'Estampilla pro Universidad del Tolima',
  '1.1.01.02.300.29': 'Estampilla pro desarrollo del Instituto Tolimense de Formación Técnica Profesional',
  '1.1.01.02.300.30': 'Estampilla pro Universidad del Valle',
  '1.1.01.02.300.31': 'Estampilla pro Universidad Tecnológica de Pereira',
  '1.1.01.02.300.32': 'Estampilla pro Universidad Pedagógica y Tecnológica de Colombia',
  '1.1.01.02.300.33': 'Estampilla Universidad Distrital Francisco José de Caldas',
  '1.1.01.02.300.34': 'Estampilla pro desarrollo del Instituto Tecnológico de Soledad, Atlántico',
  '1.1.01.02.300.35': 'Estampilla pro desarrollo Unidad Central del Valle del Cauca',
  '1.1.01.02.300.36': 'Estampilla pro desarrollo de la Institución Universitaria de Envigado',
  '1.1.01.02.300.37': 'Estampilla Politécnico Colombiano Jaime Isaza Cadavid',
  '1.1.01.02.300.38': 'Estampilla pro hospitales primer y segundo nivel del Atlántico',
  '1.1.01.02.300.39': 'Estampilla pro hospitales San Juan de Dios y Gilberto Mejía  de Rionegro Antioquia',
  '1.1.01.02.300.40': 'Estampilla pro hospitales públicos de Antioquia',
  '1.1.01.02.300.41': 'Estampilla pro hospitales del Guaviare',
  '1.1.01.02.300.42': 'Estampilla pro salud departamental del Valle del Cauca',
  '1.1.01.02.300.43': 'Estampilla pro Hospital de Caldas',
  '1.1.01.02.300.44': 'Estampillas pro hospitales universitarios',
  '1.1.01.02.300.45': 'Estampilla pro Hospital Departamental Universitario del Quindío San Juan de Dios',
  '1.1.01.02.300.46': 'Estampilla pro salud Guainía',
  '1.1.01.02.300.47': 'Estampilla pro salud Vaupés',
  '1.1.01.02.300.48': 'Estampilla Armero 10 años',
  '1.1.01.02.300.49': 'Estampilla de fomento turístico del Meta',
  '1.1.01.02.300.50': 'Estampilla Sogamoso 2000',
  '1.1.01.02.300.51': 'Estampilla pro centro de formación artística y cultural Rodrigo Arenas Betancourt',
  '1.1.01.02.300.52': 'Estampilla Tolima 150 años de contribución a la grandeza de Colombia',
  '1.1.01.02.300.53': 'Estampilla pro empleo Antioquia',
  '1.1.01.02.300.54': 'Estampilla pro palacio de la Gobernación y Centro Administrativo Municipal de Popayán',
  '1.1.01.02.300.55': 'Estampilla pro cultura',
  '1.1.01.02.300.56': 'Estampilla pro desarrollo urbano de Santiago de Cali',
  '1.1.01.02.300.57': 'Estampilla homenaje a Carlos E. Restrepo',
  '1.1.01.02.300.58': 'Estampilla Pro hospitales públicos del Distrito de Buenaventura',
  '1.1.01.02.300.59': 'Estampilla Cincuenta años de labor de la Universidad Pedagógica Nacional',
  '1.1.01.02.300.60': 'Estampilla Pro Unitrópico',
  '1.1.01.02.300.61': 'Estampilla para la justicia familiar',
  '1.1.01.02.300.62': 'Estampilla Pro Institución Universitaria Digital de Antioquia IU-Digital',
  '1.1.01.02.300.63': 'Estampilla pro-hospitales públicos, centros de salud públicos y puestos de salud públicos del Meta',
  '1.1.02': 'Ingresos no tributarios',
  '1.1.02.01': 'Contribuciones',
  '1.1.02.01.003': 'Contribuciones especiales',
  '1.1.02.01.003.01': 'Cuota de fiscalización y auditaje',
  '1.1.02.01.005': 'Contribuciones diversas',
  '1.1.02.01.005.39': 'Contribución de Valorización',
  '1.1.02.01.005.59': 'Contribución especial sobre contratos de obras públicas',
  '1.1.02.01.005.61': 'Contribución de infraestructura vial y de transporte',
  '1.1.02.01.005.62': 'Contribución de infraestructura pública turística',
  '1.1.02.01.005.63': 'Participación en la plusvalía',
  '1.1.02.01.005.64': 'Contribución sector eléctrico',
  '1.1.02.01.005.64.01': 'Contribución sector eléctrico - Generadores de energía convencional',
  '1.1.02.01.005.64.02': 'Contribución sector eléctrico - Generadores de energía no convencional',
  '1.1.02.01.005.65': 'Concurso Económico - Estratificación',
  '1.1.02.01.005.70': 'Pagos en dinero por derechos de construcción y desarrollo',
  '1.1.02.01.005.71': 'Transferencia de derechos de construcción y desarrollo',
  '1.1.02.01.005.72': 'Cargas u obligaciones urbanisticas compensadas en dinero',
  '1.1.02.01.005.73': 'Compensación en dinero de la obligación de suelo destinado a VIS o VIP',
  '1.1.02.01.005.74': 'Contribución de semaforización - cuenta bajo presunción de legalidad (Bogotá)',
  '1.1.02.01.005.75': 'Contribución - Fondo de la Colección de Autores Vallecaucanos - cuenta bajo presunción de legalidad (Valle del Cauca)',
  '1.1.02.01.005.76': 'Contribución por el servicio de parqueadero o de estacionamiento en vía',
  '1.1.02.02': 'Tasas y derechos administrativos',
  '1.1.02.02.002': 'Expedición de pasaportes',
  '1.1.02.02.015': 'Certificaciones y constancias',
  '1.1.02.02.033': 'Peajes',
  '1.1.02.02.036': 'Evaluación de licencias y trámites ambientales',
  '1.1.02.02.037': 'Seguimiento a licencias y trámites ambientales',
  '1.1.02.02.052': 'Derechos de aeródromo',
  '1.1.02.02.053': 'Tasas aeroportuarias',
  '1.1.02.02.055': 'Tasa por el uso del agua',
  '1.1.02.02.063': 'Certificados catastrales',
  '1.1.02.02.084': 'Tasas fondos de seguridad',
  '1.1.02.02.085': 'Tasas fondo departamental de bomberos',
  '1.1.02.02.086': 'Tasa contributiva por concepto de contaminación ambiental',
  '1.1.02.02.087': 'Tasas por el derecho de parqueo sobre las vías públicas',
  '1.1.02.02.088': 'Tasa retributiva',
  '1.1.02.02.089': 'Tasa por aprovechamiento forestal',
  '1.1.02.02.090': 'Tasa compensatoria por caza de fauna silvestre',
  '1.1.02.02.091': 'Tasas por la actividad pesquera',
  '1.1.02.02.092': 'Tasa por ingreso a las salinas de Zipaquirá',
  '1.1.02.02.093': 'Derechos de tránsito en áreas restringidas o de alta congestión',
  '1.1.02.02.094': 'Cobros por estacionamiento en espacio público o en lotes de parqueo',
  '1.1.02.02.095': 'Plaza de mercado',
  '1.1.02.02.096': 'Contraprestación de las zonas de uso público - municipios portuarios marítimos',
  '1.1.02.02.097': 'Punto de Control turístico',
  '1.1.02.02.098': 'Tarjeta de turista',
  '1.1.02.02.099': 'Tarjeta de residente',
  '1.1.02.02.100': 'Expedición de licencias de funcionamiento de equipos de rayos X',
  '1.1.02.02.101': 'Autorización de manejo de medicamentos de control especial del Estado',
  '1.1.02.02.102': 'Derechos de tránsito',
  '1.1.02.02.110': 'Sobretasa ambiental - Peajes',
  '1.1.02.02.116': 'Derechos pecuniarios educación superior',
  '1.1.02.02.116.01': 'Servicios de educación superior (Terciaria)',
  '1.1.02.02.116.01.01': 'Nivel pregrado',
  '1.1.02.02.116.01.01.01': 'Inscripciones',
  '1.1.02.02.116.01.01.02': 'Derechos de grado',
  '1.1.02.02.116.01.01.03': 'Matrículas',
  '1.1.02.02.116.01.01.04': 'Certificaciones, constancias académicas y derechos complementarios',
  '1.1.02.02.116.01.02': 'Nivel posgrado',
  '1.1.02.02.116.01.02.01': 'Inscripciones',
  '1.1.02.02.116.01.02.02': 'Derechos de grado',
  '1.1.02.02.116.01.02.03': 'Matrículas',
  '1.1.02.02.116.01.02.04': 'Certificaciones, constancias académicas y derechos complementarios',
  '1.1.02.02.116.02': 'Derechos complementarios asociados a la educación',
  '1.1.02.02.118': 'Incentivo por Aprovechamiento de Residuos Sólidos',
  '1.1.02.02.119': 'Trámite de licencias de funcionamiento y registro de programas de Educación para el Trabajo y el Desarrollo Humano',
  '1.1.02.02.120': 'Contraprestaciones por el uso del espacio público',
  '1.1.02.02.121': 'Infraestructura nueva para minimizar la congestión',
  '1.1.02.02.122': 'Áreas de restricción vehicular',
  '1.1.02.02.123': 'Derechos de reconocimiento de personería jurídica organismos comunales - cuenta bajo presunción de legalidad (Valle del Cauca)',
  '1.1.02.02.124': 'Anulación de rótulos adhesivos de tornaguías de alcohol potable - cuenta bajo presunción de legalidad (Valle del Cauca)',
  '1.1.02.02.125': 'Rótulos de adhesivos para la expedición y legalización de tornaguías de alcohol potable - cuenta bajo presunción de legalidad  (Valle del Cauca)',
  '1.1.02.02.126': 'Rótulos de los adhesivos para la expedición y legalización de tornaguías de productos gravados con impuesto al consumo y/o participación - cuenta bajo presunción de legalidad (Valle del Cauca)',
  '1.1.02.02.127': 'Anulación de rótulos adhesivos de tornaguías de productos gravados con impuesto al consumo y/o participación - cuenta bajo presunción de legalidad (Valle del Cauca)',
  '1.1.02.02.128': 'Derechos de reformas estatutarias organismos comunales - cuenta bajo presunción de legalidad (Valle del Cauca)',
  '1.1.02.02.129': 'Derechos sobre reformas estatutarias - cuenta bajo presunción de legalidad (Valle del Cauca)',
  '1.1.02.02.130': 'Derechos de inscripción de dignatarios organismos comunales - cuenta bajo presunción de legalidad (Valle del Cauca)',
  '1.1.02.02.131': 'Derechos de inscripción de dignatarios - cuenta bajo presunción de legalidad (Valle del Cauca)',
  '1.1.02.02.132': 'Derechos de reconocimiento de personería jurídica - cuenta bajo presunción de legalidad (Valle del Cauca)',
  '1.1.02.02.134': 'Tasa de nomenclatura urbana - cuenta bajo presunción de legalidad (Bucaramanga)',
  '1.1.02.03': 'Multas, sanciones e intereses de mora',
  '1.1.02.03.001': 'Multas y sanciones',
  '1.1.02.03.001.03': 'Sanciones disciplinarias',
  '1.1.02.03.001.04': 'Sanciones contractuales',
  '1.1.02.03.001.05': 'Sanciones administrativas',
  '1.1.02.03.001.06': 'Sanciones fiscales',
  '1.1.02.03.001.09': 'Multas de tránsito y transporte',
  '1.1.02.03.001.11': 'Sanciones tributarias',
  '1.1.02.03.001.13': 'Sanciones sanitarias',
  '1.1.02.03.001.17': 'Multas y sanciones por infracciones al régimen del monopolio de juegos de suerte y azar',
  '1.1.02.03.001.18': 'Multas y sanciones por violación al régimen de venta de medicamentos controlados',
  '1.1.02.03.001.19': 'Multas de San Andrés (OCCRE)',
  '1.1.02.03.001.20': 'Multas código nacional de Seguridad y Convivencia Ciudadana',
  '1.1.02.03.001.20.01': 'Multas código nacional de Seguridad y Convivencia Ciudadana - Multas generales',
  '1.1.02.03.001.20.02': 'Multas código nacional de Seguridad y Convivencia Ciudadana - Multas especiales',
  '1.1.02.03.001.21': 'Multa por incumplimiento en el registro de marcas y herretes',
  '1.1.02.03.001.22': 'Multas ambientales',
  '1.1.02.03.001.23': 'Sanciones urbanísticas',
  '1.1.02.03.002': 'Intereses de mora',
  '1.1.02.05': 'Venta de bienes y servicios',
  '1.1.02.05.001': 'Ventas de establecimientos de mercado',
  '1.1.02.05.001.00': 'Agricultura, silvicultura y productos de la pesca',
  '1.1.02.05.001.01': 'Minerales; electricidad, gas y agua',
  '1.1.02.05.001.02': 'Productos alimenticios, bebidas y tabaco; textiles, prendas de vestir y productos de cuero',
  '1.1.02.05.001.03': 'Otros bienes transportables (excepto productos metálicos, maquinaria y equipo)',
  '1.1.02.05.001.04': 'Productos metálicos, maquinaria y equipo',
  '1.1.02.05.001.05': 'Construcción y servicios de la construcción',
  '1.1.02.05.001.06': 'Comercio y distribución; alojamiento; servicios de suministro de comidas y bebidas; servicios de transporte; y servicios de distribución de electricidad, gas y agua',
  '1.1.02.05.001.07': 'Servicios financieros y servicios conexos; servicios inmobiliarios; y servicios de arrendamiento y leasing',
  '1.1.02.05.001.08': 'Servicios prestados a las empresas y servicios de producción',
  '1.1.02.05.001.09': 'Servicios para la comunidad, sociales y personales',
  '1.1.02.05.002': 'Ventas incidentales de establecimientos no de mercado',
  '1.1.02.05.002.00': 'Agricultura, silvicultura y productos de la pesca',
  '1.1.02.05.002.01': 'Minerales; electricidad, gas y agua',
  '1.1.02.05.002.02': 'Productos alimenticios, bebidas y tabaco; textiles, prendas de vestir y productos de cuero',
  '1.1.02.05.002.03': 'Otros bienes transportables (excepto productos metálicos, maquinaria y equipo)',
  '1.1.02.05.002.04': 'Productos metálicos, maquinaria y equipo',
  '1.1.02.05.002.05': 'Construcción y servicios de la construcción',
  '1.1.02.05.002.06': 'Comercio y distribución; alojamiento; servicios de suministro de comidas y bebidas; servicios de transporte; y servicios de distribución de electricidad, gas y agua',
  '1.1.02.05.002.07': 'Servicios financieros y servicios conexos; servicios inmobiliarios; y servicios de arrendamiento y leasing',
  '1.1.02.05.002.08': 'Servicios prestados a las empresas y servicios de producción',
  '1.1.02.05.002.09': 'Servicios para la comunidad, sociales y personales',
  '1.1.02.06': 'Transferencias corrientes',
  '1.1.02.06.001': 'Sistema General de Participaciones',
  '1.1.02.06.001.01': 'Participación para educación',
  '1.1.02.06.001.01.01': 'Prestación de servicio educativo',
  '1.1.02.06.001.01.02': 'Cancelación de prestaciones sociales del magisterio',
  '1.1.02.06.001.01.03': 'Calidad',
  '1.1.02.06.001.01.03.01': 'Calidad  por matrícula oficial',
  '1.1.02.06.001.01.03.02': 'Calidad  por gratuidad',
  '1.1.02.06.001.02': 'Participación para salud',
  '1.1.02.06.001.02.01': 'Régimen subsidiado',
  '1.1.02.06.001.02.02': 'Salud pública',
  '1.1.02.06.001.02.04': 'Subsidio a la oferta',
  '1.1.02.06.001.03': 'Participación para propósito general',
  '1.1.02.06.001.03.01': 'Deporte y recreación',
  '1.1.02.06.001.03.02': 'Cultura',
  '1.1.02.06.001.03.03': 'Propósito general Libre inversión',
  '1.1.02.06.001.03.04': 'Propósito general libre destinación municipios categorías 4, 5 y 6',
  '1.1.02.06.001.04': 'Asignaciones especiales',
  '1.1.02.06.001.04.01': 'Programas de alimentación escolar',
  '1.1.02.06.001.04.02': 'Municipios de la ribera del río Magdalena',
  '1.1.02.06.001.05': 'Agua potable y saneamiento básico',
  '1.1.02.06.001.06': 'Atención integral de la primera infancia',
  '1.1.02.06.003': 'Participaciones distintas del SGP',
  '1.1.02.06.003.01': 'Participación en impuestos',
  '1.1.02.06.003.01.01': 'Participación del impuesto nacional a la explotación de oro, plata y platino',
  '1.1.02.06.003.01.02': 'Participación del impuesto sobre vehículos automotores',
  '1.1.02.06.003.01.03': 'Participación Providencia',
  '1.1.02.06.003.01.04': 'Participación del componente ad valorem del consumo de cigarrillos y tabaco elaborado',
  '1.1.02.06.003.01.05': 'Participación del impuesto de registro',
  '1.1.02.06.003.01.06': 'Participación del impuesto adicional del 10% a las cajetillas de cigarrillos nacionales',
  '1.1.02.06.003.01.07': 'Participación del componente ad valorem del consumo de cigarrillos y tabaco',
  '1.1.02.06.003.01.08': 'Participación del impuesto al degüello de ganado mayor (en los términos que los defina la Ordenanza)',
  '1.1.02.06.003.01.09': 'Participación del IVA antiguas intendencias y comisarías',
  '1.1.02.06.003.01.10': 'Participación de la sobretasa al ACPM',
  '1.1.02.06.003.01.11': 'Participación del impuesto nacional al consumo del servicio de telefonía móvil',
  '1.1.02.06.003.01.12': 'Participación del IVA licores, vinos, aperitivos y similares',
  '1.1.02.06.003.02': 'Participación en contribuciones',
  '1.1.02.06.003.02.01': 'Participación superávit de las contribuciones de solidaridad de servicios públicos',
  '1.1.02.06.003.02.02': 'Participación de la contribución parafiscal cultural',
  '1.1.02.06.003.03': 'Participación en multas, sanciones e intereses de mora',
  '1.1.02.06.003.03.01': 'Participación de sanciones del impuesto sobre vehículos automotores',
  '1.1.02.06.003.03.02': 'Participación de intereses de mora sobre el impuesto sobre vehículos automotores',
  '1.1.02.06.003.04': 'Participación en derechos económicos por el uso de recursos naturales',
  '1.1.02.06.003.04.01': 'Participación en regalías del régimen anterior',
  '1.1.02.06.003.04.01.01': 'Regalías por calizas, yesos, arcillas, gravas , minerales no metálicos y materiales de construcción',
  '1.1.02.06.003.04.01.02': 'Regalías por carbón',
  '1.1.02.06.003.04.01.03': 'Regalías por hidrocarburos, petróleo y gas',
  '1.1.02.06.003.04.01.04': 'Regalías por Níquel, hierro, cobre y demás minerales metálicos',
  '1.1.02.06.003.04.01.05': 'Regalías por oro, plata, platino y piedras preciosas',
  '1.1.02.06.003.04.01.06': 'Regalías por sal',
  '1.1.02.06.004': 'Compensaciones de ingresos tributarios y no tributarios',
  '1.1.02.06.004.01': 'Compensación por menor recaudo de los derechos de explotación del juego de apuestas permanentes',
  '1.1.02.06.004.02': 'Compensación Impuesto Predial Unificado territorios colectivos de comunidades negras',
  '1.1.02.06.004.03': 'Compensación Impuesto Predial Unificado resguardos indígenas',
  '1.1.02.06.005': 'A entidades territoriales distintas de participaciones y compensaciones',
  '1.1.02.06.005.01': 'Suministro de medicamentos de leishmaniasis',
  '1.1.02.06.005.02': 'Prevención de la farmacodependencia y de medicamentos de control especial',
  '1.1.02.06.005.03': 'Fondo de Desarrollo para la Guajira - FONDEG',
  '1.1.02.06.005.04': 'Aportes a programas de prevención y control de enfermedades transmitidas por vectores',
  '1.1.02.06.005.05': 'Transferir a las entidades territoriales para apoyar la operación del programa de alimentación escolar',
  '1.1.02.06.005.06': 'A instituciones de educación superior - establecimientos públicos del orden territorial',
  '1.1.02.06.005.07': 'Transferencia a Fondos Territoriales de Mitigación del Riesgo',
  '1.1.02.06.005.08': 'Transferencia de recursos para la descontaminación ambiental de Barrancabermeja',
  '1.1.02.06.005.09': 'Atención en salud a población Inimputable por trastorno mental',
  '1.1.02.06.005.10': 'Programa atención áreas marginadas y población dispersa',
  '1.1.02.06.005.11': 'Campaña y control antituberculosis',
  '1.1.02.06.005.12': 'Campañas control Lepra',
  '1.1.02.06.005.13': 'Organización y funcionamiento Departamento del Amazonas, Guanía, Guaviare, Vaupés y Vichada',
  '1.1.02.06.005.14': 'Departamento Archipiélago de San Andrés, Providencia y Santa Catalina (Ley 1a. de 1972)',
  '1.1.02.06.006': 'Transferencias de otras entidades del gobierno general',
  '1.1.02.06.006.01': 'Aportes Nación',
  '1.1.02.06.006.02': 'Devolución IVA- instituciones de educación superior',
  '1.1.02.06.006.06': 'Otras unidades de gobierno',
  '1.1.02.06.006.08': 'Programas de acceso y permanencia a la educación superior',
  '1.1.02.06.006.09': 'Recursos para el mejoramiento de vivienda urbana y rural',
  '1.1.02.06.009': 'Recursos del Sistema de Seguridad Social Integral',
  '1.1.02.06.009.01': 'Sistema General de Seguridad Social en Salud',
  '1.1.02.06.009.01.06': 'Recursos ADRES - Cofinanciación UPC régimen subsidiado',
  '1.1.02.06.009.01.08': 'Saldos de liquidación de los contratos para el aseguramiento en el régimen subsidiado',
  '1.1.02.06.009.01.09': 'Transferencia Cajas de Compensación Familiar - Financiación del Régimen Subsidiado en Salud - Ley 100 de 1993',
  '1.1.02.06.009.01.11': 'Aportes de unidades del gobierno general para el financiamiento del SGSSS',
  '1.1.02.06.009.01.11.01': 'Aportes de la Nación para el aseguramiento en salud',
  '1.1.02.06.009.01.11.09': 'Recursos departamentales para Aseguramiento del Régimen Subsidiado',
  '1.1.02.06.009.02': 'Sistema General de Pensiones',
  '1.1.02.06.009.02.02': 'Cuotas partes pensionales',
  '1.1.02.06.010': 'Sentencias y conciliaciones',
  '1.1.02.06.010.01': 'Fallos nacionales',
  '1.1.02.06.010.01.01': 'Sentencias',
  '1.1.02.06.010.01.02': 'Conciliaciones',
  '1.1.02.06.010.01.03': 'Laudos arbitrales',
  '1.1.02.06.010.02': 'Fallos internacionales',
  '1.1.02.06.011': 'Indemnizaciones relacionadas con seguros no de vida',
  '1.1.02.06.020': 'Devoluciones seguridad social - pensiones',
  '1.1.02.07': 'Participación y derechos por monopolio',
  '1.1.02.07.001': 'Derechos por la explotación juegos de suerte y azar',
  '1.1.02.07.001.01': 'Derechos por la explotación juegos de suerte y azar de eventos hípicos',
  '1.1.02.07.001.02': 'Derechos por la explotación juegos de suerte y azar de lotería instantánea y lotto impreso',
  '1.1.02.07.001.03': 'Derechos por la explotación juegos de suerte y azar de lotería tradicional',
  '1.1.02.07.001.04': 'Derechos por la explotación juegos de suerte y azar de apuestas permanentes o chance',
  '1.1.02.07.001.05': 'Derechos por la explotación juegos de suerte y azar de rifas',
  '1.1.02.07.001.06': 'Derechos por la explotación juegos de suerte y azar de juegos promocionales',
  '1.1.02.07.001.07': 'Derechos por la explotación juegos de suerte y azar de juegos localizados',
  '1.1.02.07.001.08': 'Derechos por la explotación juegos de suerte y azar de eventos deportivos, gallísticos, caninos y similares',
  '1.1.02.07.001.09': 'Derechos por la explotación juegos de suerte y azar de juegos novedosos',
  '1.1.02.07.002': 'Participación y derechos de explotación del ejercicio del monopolio de licores destilados y alcoholes potables',
  '1.1.02.07.002.01': 'Participación y derechos de explotación del ejercicio del monopolio de licores destilados',
  '1.1.02.07.002.01.01': 'Derechos de monopolio por la producción de licores destilados',
  '1.1.02.07.002.01.02': 'Derechos de monopolio por la introducción de licores destilados',
  '1.1.02.07.002.01.02.01': 'Derechos de monopolio por la introducción de licores destilados de producción nacional',
  '1.1.02.07.002.01.02.02': 'Derechos de monopolio por la introducción de licores destilados de producción extranjera',
  '1.1.02.07.002.01.03': 'Participación por el consumo de licores destilados',
  '1.1.02.07.002.01.03.01': 'Participación por el consumo de licores destilados producidos',
  '1.1.02.07.002.01.03.02': 'Participación por el consumo de licores destilados introducidos',
  '1.1.02.07.002.01.03.02.01': 'Participación por el consumo de licores destilados introducidos de producción nacional',
  '1.1.02.07.002.01.03.02.02': 'Participación por el consumo de licores destilados introducidos de producción extranjera',
  '1.1.02.07.002.01.03.02.02.01': 'Participación por el consumo de licores destilados introducidos de producción extranjera recaudado por fondo cuenta de la FND',
  '1.1.02.07.002.01.03.02.02.02': 'Participación por el consumo de licores destilados introducidos de producción extranjera recaudado por el departamento',
  '1.1.02.07.002.02': 'Participación sobre el alcohol potable con destino a la fabricación de licores',
  '1.1.02.07.002.02.01': 'Participación por la utilización de alcohol potable producido',
  '1.1.02.07.002.02.02': 'Derechos por la explotación de alcohol potable introducido',
  '1.1.02.07.002.02.02.01': 'Derechos por la explotación de alcohol potable introducido de producción nacional',
  '1.1.02.07.002.02.02.02': 'Derechos por la explotación de alcohol potable introducido de producción extranjera',
  '1.2': 'Recursos de capital',
  '1.2.01': 'Disposición de activos',
  '1.2.01.01': 'Disposición de activos financieros',
  '1.2.01.01.001': 'Acciones',
  '1.2.01.01.002': 'Reducciones de capital',
  '1.2.01.01.003': 'Reembolso de participaciones en fondos de inversión',
  '1.2.01.01.005': 'Bonos y otros títulos emitidos',
  '1.2.01.02': 'Disposición de activos no financieros',
  '1.2.01.02.001': 'Disposición de activos fijos',
  '1.2.01.02.001.01': 'Disposición de edificaciones y estructuras',
  '1.2.01.02.001.02': 'Disposición de maquinaria y equipo',
  '1.2.01.02.001.03': 'Disposición de otros activos fijos',
  '1.2.01.02.001.03.01': 'Disposición de recursos biológicos cultivados',
  '1.2.01.02.001.03.02': 'Disposición de productos de la propiedad intelectual',
  '1.2.01.02.002': 'Disposición de objetos de valor',
  '1.2.01.02.002.01': 'Disposición de joyas y artículos conexos',
  '1.2.01.02.002.02': 'Disposición de antigüedades u otros objetos de arte',
  '1.2.01.02.002.03': 'Disposición de otros objetos valiosos',
  '1.2.01.02.003': 'Disposición de activos no producidos',
  '1.2.01.02.003.01': 'Disposición de  tierras y terrenos',
  '1.2.01.02.003.02': 'Disposición de recursos biológicos no cultivados',
  '1.2.02': 'Excedentes financieros',
  '1.2.02.01': 'Establecimientos públicos',
  '1.2.02.02': 'Empresas industriales y comerciales del Estado no societarias',
  '1.2.02.03': 'Fondos de Desarrollo Local Distrito de Bogotá',
  '1.2.03': 'Dividendos y utilidades por otras inversiones de capital',
  '1.2.03.02': 'Empresas industriales y comerciales del Estado societarias',
  '1.2.03.03': 'Sociedades de economía mixta',
  '1.2.03.04': 'Inversiones patrimoniales no controladas',
  '1.2.03.05': 'Inversiones en entidades controladas - entidades en el exterior',
  '1.2.03.06': 'Inversiones en entidades controladas - sociedades públicas',
  '1.2.05': 'Rendimientos financieros',
  '1.2.05.01': 'Títulos participativos',
  '1.2.05.02': 'Depósitos',
  '1.2.05.03': 'Valores distintos de acciones',
  '1.2.05.04': 'Cuenta única nacional',
  '1.2.05.05': 'Intereses por préstamos',
  '1.2.05.06': 'Rendimientos recursos de terceros',
  '1.2.06': 'Recursos de crédito externo',
  '1.2.06.01': 'Recursos de contratos de empréstitos externos',
  '1.2.06.01.001': 'Bancos comerciales',
  '1.2.06.01.002': 'Entidades de fomento',
  '1.2.06.01.003': 'Gobiernos',
  '1.2.06.01.003.01': 'Bancos centrales y agencias de gobiernos',
  '1.2.06.01.003.02': 'Gobiernos',
  '1.2.06.01.004': 'Organismos multilaterales',
  '1.2.06.01.004.01': 'BID',
  '1.2.06.01.004.02': 'BIRF',
  '1.2.06.01.004.03': 'CAF',
  '1.2.06.01.005': 'Otras instituciones financieras',
  '1.2.06.01.005.01': 'FIDA',
  '1.2.06.01.005.02': 'FODI',
  '1.2.06.01.005.03': 'Recursos de crédito externo de otras instituciones financieras',
  '1.2.06.02': 'Títulos de deuda',
  '1.2.06.02.001': 'Bonos',
  '1.2.07': 'Recursos de crédito interno',
  '1.2.07.01': 'Recursos de contratos de empréstitos internos',
  '1.2.07.01.001': 'Banca comercial',
  '1.2.07.01.002': 'Nación',
  '1.2.07.01.003': 'Banca de fomento',
  '1.2.07.01.004': 'Institutos de Desarrollo Departamental y/o Municipal',
  '1.2.07.01.006': 'Otras instituciones financieras',
  '1.2.07.01.007': 'Otras entidades no financieras',
  '1.2.07.02': 'Títulos de deuda',
  '1.2.07.02.002': 'Bonos y otros títulos emitidos',
  '1.2.08': 'Transferencias de capital',
  '1.2.08.01': 'Donaciones',
  '1.2.08.01.001': 'De gobiernos extranjeros',
  '1.2.08.01.001.01': 'No condicionadas a la adquisición de un activo',
  '1.2.08.01.001.02': 'Condicionadas a la adquisición de un activo',
  '1.2.08.01.002': 'De organizaciones internacionales',
  '1.2.08.01.002.01': 'No condicionadas a la adquisición de un activo',
  '1.2.08.01.002.02': 'Condicionadas a la adquisición de un activo',
  '1.2.08.01.003': 'Del sector privado',
  '1.2.08.01.003.01': 'No condicionadas a la adquisición de un activo',
  '1.2.08.01.003.02': 'Condicionadas a la adquisición de un activo',
  '1.2.08.02': 'Indemnizaciones relacionadas con seguros no de vida',
  '1.2.08.03': 'Compensaciones de capital',
  '1.2.08.03.001': 'Resarcimiento por procesos de gestión fiscal',
  '1.2.08.03.002': 'Compensación por daños a la propiedad',
  '1.2.08.04': 'Premios no reclamados',
  '1.2.08.04.001': 'Premios de juegos de suerte y azar',
  '1.2.08.04.002': 'Premios de loterías',
  '1.2.08.04.003': 'Premios de apuestas permanentes o chance',
  '1.2.08.04.004': 'Premios de juegos novedosos',
  '1.2.08.05': 'Reembolso fondo de contingencias',
  '1.2.08.06': 'De otras entidades del gobierno general',
  '1.2.08.06.001': 'Fondo de Subsidio de la Sobretasa a la Gasolina',
  '1.2.08.06.002': 'Condicionadas a la adquisición de un activo',
  '1.2.08.06.003': 'Condicionadas a la disminución de un pasivo',
  '1.2.09': 'Recuperación de cartera - préstamos',
  '1.2.09.02': 'De otras entidades de gobierno',
  '1.2.09.03': 'De personas naturales',
  '1.2.09.04': 'De otras empresas',
  '1.2.09.05': 'Recuperación cuotas partes pensionales',
  '1.2.10': 'Recursos del balance',
  '1.2.10.01': 'Cancelación reservas',
  '1.2.10.02': 'Superávit fiscal',
  '1.2.11': 'Diferencial cambiario',
  '1.2.12': 'Retiros FONPET',
  '1.2.12.01': 'Para el pago de bonos pensionales o cuotas partes de bonos pensionales',
  '1.2.12.01.001': 'Para el pago de bonos y cuotas partes de bonos pensionales A y B',
  '1.2.12.01.002': 'Para el pago de bonos y cuotas partes de bonos pensionales C y E',
  '1.2.12.02': 'Para el cruce y pago de cuotas partes pensionales',
  '1.2.12.03': 'Para el pago de la deuda por docentes al Fondo de Prestaciones Sociales del Magisterio (FPSM)',
  '1.2.12.03.001': 'Para el pago del pasivo pensional corriente',
  '1.2.12.03.002': 'Para el pago del monto consolidado de la deuda',
  '1.2.12.04': 'Recursos de Lotto en línea',
  '1.2.12.04.001': 'Para pagar el pasivo pensional con el sector salud',
  '1.2.12.04.002': 'Para invertir en la atención de los servicios de salud',
  '1.2.12.05': 'Por el reembolso de pago de bonos pensionales',
  '1.2.12.06': 'Por la devolución de consignación errónea',
  '1.2.12.07': 'Por el retiro de recursos hasta por el 30% del saldo en cuenta',
  '1.2.12.08': 'Del excedente del cubrimiento del pasivo pensional',
  '1.2.12.09': 'Para el pago de obligaciones pensionales corrientes',
  '1.2.12.10': 'Por la devolución de recursos SGP Propósito General',
  '1.2.12.11': 'Por la devolución de recursos SGR',
  '1.2.13': 'Reintegros y otros recursos no apropiados',
  '1.2.13.01': 'Reintegros',
  '1.2.13.02': 'Recursos no apropiados',
};

const CCPET_TIPO_A = new Set([
  '1',
  '1.1',
  '1.1.01',
  '1.1.01.01',
  '1.1.01.01.014',
  '1.1.01.01.200',
  '1.1.01.02',
  '1.1.01.02.100',
  '1.1.01.02.104',
  '1.1.01.02.104.01',
  '1.1.01.02.104.01.01',
  '1.1.01.02.104.01.02',
  '1.1.01.02.104.02',
  '1.1.01.02.104.02.01',
  '1.1.01.02.104.02.02',
  '1.1.01.02.105',
  '1.1.01.02.106',
  '1.1.01.02.106.01',
  '1.1.01.02.106.02',
  '1.1.01.02.200',
  '1.1.01.02.217',
  '1.1.01.02.300',
  '1.1.02',
  '1.1.02.01',
  '1.1.02.01.003',
  '1.1.02.01.005',
  '1.1.02.01.005.64',
  '1.1.02.02',
  '1.1.02.02.116',
  '1.1.02.02.116.01',
  '1.1.02.02.116.01.01',
  '1.1.02.02.116.01.02',
  '1.1.02.03',
  '1.1.02.03.001',
  '1.1.02.03.001.20',
  '1.1.02.05',
  '1.1.02.05.001',
  '1.1.02.05.002',
  '1.1.02.06',
  '1.1.02.06.001',
  '1.1.02.06.001.01',
  '1.1.02.06.001.01.03',
  '1.1.02.06.001.02',
  '1.1.02.06.001.03',
  '1.1.02.06.001.04',
  '1.1.02.06.003',
  '1.1.02.06.003.01',
  '1.1.02.06.003.02',
  '1.1.02.06.003.03',
  '1.1.02.06.003.04',
  '1.1.02.06.003.04.01',
  '1.1.02.06.004',
  '1.1.02.06.005',
  '1.1.02.06.006',
  '1.1.02.06.009',
  '1.1.02.06.009.01',
  '1.1.02.06.009.01.11',
  '1.1.02.06.009.02',
  '1.1.02.06.010',
  '1.1.02.06.010.01',
  '1.1.02.07',
  '1.1.02.07.001',
  '1.1.02.07.002',
  '1.1.02.07.002.01',
  '1.1.02.07.002.01.02',
  '1.1.02.07.002.01.03',
  '1.1.02.07.002.01.03.02',
  '1.1.02.07.002.01.03.02.02',
  '1.1.02.07.002.02',
  '1.1.02.07.002.02.02',
  '1.2',
  '1.2.01',
  '1.2.01.01',
  '1.2.01.02',
  '1.2.01.02.001',
  '1.2.01.02.001.03',
  '1.2.01.02.002',
  '1.2.01.02.003',
  '1.2.02',
  '1.2.03',
  '1.2.05',
  '1.2.06',
  '1.2.06.01',
  '1.2.06.01.003',
  '1.2.06.01.004',
  '1.2.06.01.005',
  '1.2.06.02',
  '1.2.07',
  '1.2.07.01',
  '1.2.07.02',
  '1.2.08',
  '1.2.08.01',
  '1.2.08.01.001',
  '1.2.08.01.002',
  '1.2.08.01.003',
  '1.2.08.03',
  '1.2.08.04',
  '1.2.08.06',
  '1.2.09',
  '1.2.10',
  '1.2.12',
  '1.2.12.01',
  '1.2.12.03',
  '1.2.12.04',
  '1.2.13',
]);

const fCOP = v => {
  if (!v && v !== 0) return "—";
  return new Intl.NumberFormat("es-CO",{style:"currency",currency:"COP",
    minimumFractionDigits:0,maximumFractionDigits:0}).format(Number(v)||0);
};

async function parsearExcel(file) {
  if (!window.XLSX) {
    await new Promise((res, rej) => {
      const s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
      s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
  }
  const buffer = await file.arrayBuffer();
  const wb = window.XLSX.read(buffer, { type: 'array' });
  const ws = wb.Sheets[wb.SheetNames[0]];
  const raw = window.XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });

  const hIdx = raw.findIndex(r => r.some(c => String(c).trim().toUpperCase() === 'CCPET'));
  if (hIdx < 0) throw new Error("No se encontró columna CCPET.");

  const headers = raw[hIdx].map(h => String(h).trim().toUpperCase());
  const iCcpet    = headers.indexOf('CCPET');
  const iResumido = headers.findIndex(h => h.includes('RESUMIDO') || h === 'CONS.' || h === 'CONS');
  const iNombre   = headers.findIndex(h => h.includes('NOMBRE'));
  const iFuente   = headers.findIndex(h => h.includes('FUENTE FINANCIACION') || h.includes('FUENTE DE FINANCIACION'));
  const iNomFuente= headers.findIndex(h => h.includes('NOMBRE FUENTE'));
  const iObs      = headers.findIndex(h => h.includes('OBSERVACION'));
  const iFondo    = headers.findIndex(h => h.includes('FONDO'));

  // ── Buscar columna VALOR con fallbacks para el reporte de ejecución ──
  let iValor = headers.findIndex(h => h === 'VALOR');
  let colValorUsada = 'VALOR';
  if (iValor < 0) {
    // Intentar con ADICIONES primero (para Adición Presupuestal)
    iValor = headers.findIndex(h => h === 'ADICIONES');
    if (iValor >= 0) colValorUsada = 'ADICIONES';
  }
  if (iValor < 0) {
    // Fallback: PRESUPUESTO DEFINITIVO
    iValor = headers.findIndex(h => h.includes('PRESUPUESTO DEFINITIVO'));
    if (iValor >= 0) colValorUsada = 'PRESUPUESTO DEFINITIVO';
  }

  // ── Parser de números colombianos ──
  const toNum = (v) => {
    if (v === '' || v === null || v === undefined) return null;
    if (typeof v === 'number') return v;
    let s = String(v).replace(/\s/g, '').trim();
    if (s === '' || s === '-' || s === '—') return null;
    // Formato colombiano: 1.234.567,89 → quitar puntos, cambiar coma por punto
    const tienePunto = s.includes('.');
    const tieneComma = s.includes(',');
    if (tienePunto && tieneComma) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (tieneComma && !tienePunto) {
      s = s.replace(',', '.');
    } else if (tienePunto && !tieneComma) {
      // Si hay más de un punto, son separadores de miles
      if ((s.match(/\./g) || []).length > 1) s = s.replace(/\./g, '');
      else {
        // Un solo punto: ver si la parte decimal tiene 3 dígitos → es miles
        const partes = s.split('.');
        if ((partes[1] || '').length === 3) s = s.replace('.', '');
      }
    }
    const n = parseFloat(s);
    return isNaN(n) ? null : n;
  };

  const filas = [];
  for (let i = hIdx + 1; i < raw.length; i++) {
    const r = raw[i];
    const ccpet = String(r[iCcpet] ?? '').trim();
    if (!ccpet) continue;
    const resumido  = iResumido >= 0  ? String(r[iResumido] ?? '').trim()  : '';
    const nombre    = iNombre >= 0    ? String(r[iNombre] ?? '').trim()    : '';
    const fuente    = iFuente >= 0    ? String(r[iFuente] ?? '').trim()    : '';
    const nomFuente = iNomFuente >= 0 ? String(r[iNomFuente] ?? '').trim() : '';
    const valorRaw  = iValor >= 0     ? r[iValor] : '';
    const obs       = iObs >= 0       ? String(r[iObs] ?? '').trim()       : '';
    const fondo     = iFondo >= 0     ? String(r[iFondo] ?? '').trim()     : '';
    const esTitulo  = !resumido || resumido === 'nan' || resumido === '';
    const valor     = esTitulo ? null : toNum(valorRaw);
    filas.push({
      ccpet, resumido,
      nombre: nombre || nomFuente || CCPET_NOMBRES[ccpet] || ccpet,
      fuente, nomFuente, valor, obs, fondo, esTitulo
    });
  }

  console.log(`✅ Columna usada como VALOR: "${colValorUsada}" | Filas: ${filas.length}`);
  return filas;
}

function totalTipoA(filas, ccpet) {
  const pref=ccpet+'.';
  return filas.filter(r=>!r.esTitulo&&(r.ccpet===ccpet||r.ccpet.startsWith(pref)))
    .reduce((s,r)=>s+(r.valor||0),0);
}

function totalGeneral(filas) {
  return filas.filter(r=>!r.esTitulo).reduce((s,r)=>s+(r.valor||0),0);
}

function TablaPartida({filas, setFilas, busqueda, accentColor}) {
  const [editKey, setEditKey] = useState(null); // clave de la fila en edición

  const thH={padding:"0.5rem 0.7rem",background:accentColor,color:"#fff",
    fontWeight:700,fontSize:"0.72rem",textAlign:"left",whiteSpace:"nowrap"};

  const fltFilas = filas.filter(r=>{
    const q=busqueda.toLowerCase();
    return !q||r.ccpet.toLowerCase().includes(q)||r.nombre.toLowerCase().includes(q)||(r.fondo||'').toLowerCase().includes(q);
  });

  const rowKey = r => r.ccpet + "||" + (r.resumido||"");

  const actualizarFila = (key, campo, valor) => {
    setFilas(prev => prev.map(r =>
      rowKey(r) === key ? {...r, [campo]: campo==="valor"?(valor===""?null:Number(valor)||0):valor} : r
    ));
  };

  return (
    <div style={{overflowX:"auto"}}>
      <p style={{margin:"0 0 0.5rem",padding:"0.5rem 0.75rem",fontSize:"0.75rem",
        color:"#6b7280",background:"#fffbeb",borderBottom:"1px solid #fde68a"}}>
        💡 <strong>Doble clic</strong> sobre el valor de una fila para editarlo — se abre el campo de observaciones automáticamente.
      </p>
      <table style={{width:"100%",borderCollapse:"collapse"}}>
        <thead><tr>
          <th style={thH}>CCPET</th>
          <th style={thH}>C.RES</th>
          <th style={{...thH,minWidth:"260px"}}>NOMBRE</th>
          <th style={{...thH,minWidth:"180px"}}>FUENTE FINANCIACIÓN</th>
          <th style={{...thH,textAlign:"right",minWidth:"130px"}}>VALOR</th>
          <th style={{...thH,minWidth:"200px"}}>OBSERVACIONES</th>
          <th style={thH}>FONDO</th>
        </tr></thead>
        <tbody>
          {fltFilas.map((r,i)=>{
            if(r.esTitulo){
              const nivel=(r.ccpet.match(/\./g)||[]).length;
              const indent=nivel*14;
              const peso=nivel===0?800:nivel<=1?700:nivel<=3?600:500;
              const bgT=nivel===0?"#1e3a8a":nivel===1?"#1e40af":nivel===2?"#2563eb":nivel===3?"#dbeafe":"#eff6ff";
              const ctT=nivel<=2?"#fff":"#1e3a8a";
              const total=totalTipoA(filas,r.ccpet);
              return (
                <tr key={r.ccpet+i} style={{borderBottom:"1px solid #e5e7eb"}}>
                  <td style={{padding:"0.5rem 0.7rem",background:bgT,fontFamily:"monospace",
                    fontSize:"0.7rem",color:nivel<=2?"#93c5fd":"#1e40af",fontWeight:peso}}>{r.ccpet}</td>
                  <td style={{padding:"0.5rem 0.7rem",background:bgT,color:ctT,fontSize:"0.7rem"}}>—</td>
                  <td style={{padding:`0.5rem 0.7rem 0.5rem ${indent+10}px`,background:bgT,
                    color:ctT,fontWeight:peso,fontSize:"0.8rem",maxWidth:"320px"}}>
                    {CCPET_NOMBRES[r.ccpet]||r.nombre||r.ccpet}
                  </td>
                  <td style={{padding:"0.5rem 0.7rem",background:bgT,color:ctT,fontSize:"0.7rem"}}>—</td>
                  <td style={{padding:"0.5rem 0.7rem",background:nivel<=2?"#065f46":"#dcfce7",
                    textAlign:"right",fontFamily:"monospace",fontWeight:peso,
                    color:nivel<=2?"#a7f3d0":"#065f46",fontSize:"0.78rem"}}>
                    {total>0?fCOP(total):"—"}
                  </td>
                  <td style={{padding:"0.5rem 0.7rem",background:bgT,color:ctT,fontSize:"0.7rem"}}>—</td>
                  <td style={{padding:"0.5rem 0.7rem",background:bgT,color:ctT,fontSize:"0.7rem"}}>—</td>
                </tr>
              );
            }

            // ── Fila detalle editable ──
            const bg   = i%2===0?"#f9fafb":"#fff";
            const rk   = rowKey(r);
            const edit = editKey === rk;

            return (
              <tr key={rk} style={{borderBottom:"1px solid #e5e7eb",
                outline: edit?"2px solid #3b82f6":"none",
                outlineOffset:"-1px"}}>
                <td style={{padding:"0.4rem 0.7rem",background:bg}}>
                  <code style={{fontSize:"0.68rem",color:"#374151"}}>{r.ccpet}</code>
                </td>
                <td style={{padding:"0.4rem 0.7rem",background:bg,fontSize:"0.7rem",color:"#6b7280"}}>
                  {r.resumido||"—"}
                </td>
                <td style={{padding:"0.4rem 0.7rem",background:bg,fontSize:"0.78rem",maxWidth:"260px"}}>{r.nombre}</td>
                <td style={{padding:"0.4rem 0.7rem",background:bg,fontSize:"0.7rem",color:"#6b7280",maxWidth:"180px"}}>
                  {r.fuente||r.nomFuente||"—"}
                </td>

                {/* VALOR — doble clic para editar */}
                <td style={{padding:"0.4rem 0.7rem",background:edit?"#eff6ff":bg,
                  textAlign:"right",cursor:"pointer"}}
                  title="Doble clic para editar"
                  onDoubleClick={()=>setEditKey(edit?null:rk)}>
                  {edit ? (
                    <input
                      type="number"
                      autoFocus
                      value={r.valor??''}
                      onChange={e=>actualizarFila(rk,"valor",e.target.value)}
                      onBlur={()=>{}} // no cerrar al salir del valor, obs sigue abierto
                      style={{width:"110px",border:"1px solid #3b82f6",borderRadius:"6px",
                        padding:"0.25rem 0.4rem",fontSize:"0.78rem",textAlign:"right",
                        fontFamily:"monospace",fontWeight:700,color:"#163b8c",outline:"none"}}
                    />
                  ) : (
                    <span style={{fontFamily:"monospace",fontWeight:700,fontSize:"0.78rem",
                      color:r.valor>0?"#163b8c":"#9ca3af"}}>
                      {r.valor!=null?fCOP(r.valor):"—"}
                    </span>
                  )}
                </td>

                {/* OBSERVACIONES — visible siempre, editable cuando está en modo edición */}
                <td style={{padding:"0.4rem 0.7rem",background:edit?"#fffbeb":bg,maxWidth:"220px"}}>
                  {edit ? (
                    <input
                      type="text"
                      placeholder="Escribe la observación..."
                      value={r.obs||''}
                      onChange={e=>actualizarFila(rk,"obs",e.target.value)}
                      style={{width:"100%",border:"1px solid #f59e0b",borderRadius:"6px",
                        padding:"0.25rem 0.4rem",fontSize:"0.73rem",color:"#374151",
                        outline:"none",background:"#fffbeb"}}
                    />
                  ) : (
                    <span style={{fontSize:"0.73rem",color:r.obs?"#374151":"#d1d5db"}}>
                      {r.obs||"—"}
                    </span>
                  )}
                </td>

                <td style={{padding:"0.4rem 0.7rem",background:bg}}>
                  {r.fondo&&r.fondo!=="nan"?(
                    <span style={{background:"#eff6ff",color:"#1e40af",borderRadius:"999px",
                      padding:"0.15rem 0.55rem",fontSize:"0.7rem",fontWeight:700}}>
                      {r.fondo}
                    </span>
                  ):"—"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function BloquePartida({titulo, subtitulo, accentColor, filas, setFilas, onCargar, subiendo, msg, fileRef, busqueda, setBusqueda, onDescargar, collapsed, onCollapse}) {
  return (
    <div style={{background:"#fff",borderRadius:"16px",border:"1px solid #e5e7eb",
      boxShadow:"0 4px 14px rgba(0,0,0,0.05)",marginBottom:"1.5rem",overflow:"hidden"}}>
      <div style={{padding:"1.1rem 1.5rem",borderBottom:"1px solid #e5e7eb",background:accentColor,
        display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <h2 style={{margin:0,color:"#fff",fontSize:"1.1rem",fontWeight:800}}>{titulo}</h2>
          <p style={{margin:"0.2rem 0 0",color:"rgba(255,255,255,0.8)",fontSize:"0.8rem"}}>{subtitulo}</p>
        </div>
        {filas&&onCollapse&&(
          <button type="button" onClick={onCollapse}
            style={{display:"flex",alignItems:"center",gap:"0.4rem",
              background:"rgba(255,255,255,0.15)",color:"#fff",border:"1px solid rgba(255,255,255,0.3)",
              borderRadius:"8px",padding:"0.4rem 0.85rem",fontWeight:700,fontSize:"0.82rem",
              cursor:"pointer",flexShrink:0}}>
            {collapsed?<><ChevronDown size={15}/>Expandir</>:<><ChevronUp size={15}/>Contraer</>}
          </button>
        )}
      </div>

      <div style={{padding:"1rem 1.5rem",borderBottom:"1px solid #e5e7eb",
        display:"flex",alignItems:"center",gap:"0.75rem",flexWrap:"wrap"}}>
        <input ref={fileRef} type="file" accept=".xlsx,.xls,.csv"
          style={{display:"none"}} onChange={onCargar}/>
        <button type="button" onClick={()=>fileRef.current.click()} disabled={subiendo}
          style={{display:"flex",alignItems:"center",gap:"0.5rem",
            background:subiendo?"#93c5fd":accentColor,color:"#fff",border:"none",
            borderRadius:"10px",padding:"0.65rem 1.2rem",fontWeight:700,
            cursor:subiendo?"not-allowed":"pointer",fontSize:"0.88rem"}}>
          <Upload size={16}/> {subiendo?"Procesando...":"Cargar Excel"}
        </button>
        {filas&&(<>
          <input type="text" placeholder="Buscar CCPET, nombre, fondo..."
            value={busqueda} onChange={e=>setBusqueda(e.target.value)}
            style={{padding:"0.5rem 1rem",borderRadius:"8px",border:"1px solid #d1d5db",
              fontSize:"0.85rem",minWidth:"220px",outline:"none",flex:1,maxWidth:"320px"}}/>
          <span style={{fontSize:"0.82rem",color:"#6b7280",marginLeft:"auto"}}>
            {filas.length} registros · Total: <strong>{fCOP(totalGeneral(filas))}</strong>
          </span>
          <button type="button" onClick={onDescargar}
            style={{display:"flex",alignItems:"center",gap:"0.4rem",
              background:"#374151",color:"#fff",border:"none",borderRadius:"8px",
              padding:"0.5rem 0.85rem",fontWeight:700,fontSize:"0.8rem",cursor:"pointer"}}>
            <Download size={13}/> CSV
          </button>
        </>)}
      </div>

      {!collapsed&&msg&&(
        <div style={{margin:"0.75rem 1.5rem",padding:"0.75rem 1rem",borderRadius:"10px",
          background:msg.ok?"#f0fdf4":"#fef2f2",
          border:`1px solid ${msg.ok?"#bbf7d0":"#fca5a5"}`,
          color:msg.ok?"#15803d":"#991b1b",
          display:"flex",alignItems:"center",gap:"0.5rem",fontSize:"0.88rem"}}>
          {msg.ok?<CheckCircle size={15}/>:<AlertCircle size={15}/>}{msg.t}
        </div>
      )}

      {!collapsed&&(filas
        ? <TablaPartida filas={filas} setFilas={setFilas} busqueda={busqueda} accentColor={accentColor}/>
        : <div style={{padding:"2.5rem",textAlign:"center",color:"#9ca3af",fontSize:"0.88rem"}}>
            Carga el archivo Excel para visualizar esta partida.
          </div>
      )}
    </div>
  );
}

export default function RecursosBalance() {
  const navigate = useNavigate();
  const fRefIng = useRef(), fRefEgr = useRef();

  const [filasIng, setFilasIng] = useState(null);
  const [filasEgr, setFilasEgr] = useState(null);
  const [subIng, setSubIng]     = useState(false);
  const [subEgr, setSubEgr]     = useState(false);
  const [msgIng, setMsgIng]     = useState(null);
  const [msgEgr, setMsgEgr]     = useState(null);
  const [qIng, setQIng]         = useState("");
  const [qEgr, setQEgr]         = useState("");
  const [colIng, setColIng]     = useState(false);
  const [colEgr, setColEgr]     = useState(false);

  const cargar = async (e, setFilas, setSub, setMsg) => {
    const file=e.target.files?.[0]; if(!file) return;
    e.target.value=""; setSub(true); setMsg(null);
    try {
      const filas = await parsearExcel(file);
      setFilas(filas);
      setMsg({ok:true, t:`✅ ${filas.length} filas cargadas — ${file.name}`});
    } catch(err) { setMsg({ok:false, t:`❌ ${err.message}`}); }
    setSub(false);
  };

  const descargar = (filas, nombre) => {
    if(!filas) return;
    const bom="\uFEFF";
    const cab=["CCPET","C.RES","NOMBRE","FUENTE","TIPO","VALOR","OBSERVACIONES","FONDO"].join(";");
    const rows=filas.map(r=>[
      r.ccpet, r.resumido||"", `"${r.nombre}"`, r.fuente||r.nomFuente||"",
      r.esTitulo?"Título":"Detalle",
      r.esTitulo?String(Math.round(totalTipoA(filas,r.ccpet))).replace(".",",")
               :(r.valor!=null?String(r.valor).replace(".",","):""),
      `"${r.obs||""}"`, r.fondo||""
    ].join(";"));
    const blob=new Blob([bom+cab+"\n"+rows.join("\n")],{type:"text/csv;charset=utf-8;"});
    const a=document.createElement("a"); a.href=URL.createObjectURL(blob);
    a.download=nombre; a.click(); URL.revokeObjectURL(a.href);
  };

  const totIng = filasIng ? totalGeneral(filasIng) : null;
  const totEgr = filasEgr ? totalGeneral(filasEgr) : null;
  const ambos  = totIng !== null && totEgr !== null;
  const cuadra = ambos && Math.abs(totIng - totEgr) < 1;

  return (
    <div style={{minHeight:"100vh",background:"#f3f4f6",padding:"2rem 1.5rem"}}>
      <div style={{maxWidth:"1500px",margin:"0 auto"}}>

        <button type="button" onClick={()=>navigate("/hacienda-presupuesto")}
          style={{background:"#e5e7eb",color:"#111827",border:"none",borderRadius:"10px",
            padding:"0.7rem 1rem",cursor:"pointer",fontWeight:600,marginBottom:"1.5rem"}}>
          ← Volver a Hacienda
        </button>

        <div style={{marginBottom:"1.5rem"}}>
          <h1 style={{margin:0,color:"#163b8c",fontSize:"2rem",fontWeight:800}}>
            Adición Presupuestal
          </h1>
          <p style={{marginTop:"0.5rem",color:"#6b7280"}}>
            Carga el Excel de ingresos y el de egresos — los totales deben cuadrar
          </p>
        </div>

        {/* ── Banner validación ── */}
        {ambos&&(
          <div style={{marginBottom:"1.5rem",padding:"1.1rem 1.5rem",borderRadius:"16px",
            border:`2px solid ${cuadra?"#16a34a":"#dc2626"}`,
            background:cuadra?"#f0fdf4":"#fef2f2",
            display:"flex",alignItems:"center",justifyContent:"space-between",
            flexWrap:"wrap",gap:"1rem"}}>
            <div style={{display:"flex",alignItems:"center",gap:"0.75rem"}}>
              {cuadra
                ? <CheckCircle size={28} color="#16a34a"/>
                : <XCircle size={28} color="#dc2626"/>}
              <div>
                <div style={{fontWeight:800,fontSize:"1.05rem",
                  color:cuadra?"#15803d":"#991b1b"}}>
                  {cuadra?"✅ Los totales cuadran":"⚠️ Los totales NO cuadran"}
                </div>
                {!cuadra&&<div style={{fontSize:"0.82rem",color:"#6b7280",marginTop:"0.2rem"}}>
                  Diferencia: {fCOP(Math.abs(totIng-totEgr))}
                </div>}
              </div>
            </div>
            <div style={{display:"flex",gap:"2rem",flexWrap:"wrap"}}>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:"0.75rem",color:"#6b7280",fontWeight:600}}>INGRESOS</div>
                <div style={{fontFamily:"monospace",fontWeight:800,fontSize:"1.05rem",color:"#163b8c"}}>
                  {fCOP(totIng)}
                </div>
              </div>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:"0.75rem",color:"#6b7280",fontWeight:600}}>EGRESOS</div>
                <div style={{fontFamily:"monospace",fontWeight:800,fontSize:"1.05rem",color:"#163b8c"}}>
                  {fCOP(totEgr)}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── INGRESOS ── */}
        <BloquePartida
          titulo="Ingresos"
          subtitulo="Recursos del balance — cuánto se va a recaudar"
          accentColor="#163b8c"
          filas={filasIng}
          fileRef={fRefIng}
          subiendo={subIng}
          msg={msgIng}
          busqueda={qIng}
          setBusqueda={setQIng}
          onCargar={e=>cargar(e,setFilasIng,setSubIng,setMsgIng)}
          setFilas={setFilasIng}
          onDescargar={()=>descargar(filasIng,"Adicion_Ingresos.csv")}
          collapsed={colIng}
          onCollapse={()=>setColIng(p=>!p)}
        />

        {/* ── EGRESOS ── */}
        <BloquePartida
          titulo="Egresos"
          subtitulo="Funcionamiento · Servicio de la deuda · Inversión"
          accentColor="#065f46"
          filas={filasEgr}
          fileRef={fRefEgr}
          subiendo={subEgr}
          msg={msgEgr}
          busqueda={qEgr}
          setBusqueda={setQEgr}
          onCargar={e=>cargar(e,setFilasEgr,setSubEgr,setMsgEgr)}
          setFilas={setFilasEgr}
          onDescargar={()=>descargar(filasEgr,"Adicion_Egresos.csv")}
          collapsed={colEgr}
          onCollapse={()=>setColEgr(p=>!p)}
        />

      </div>
    </div>
  );
}